import { Component } from '@angular/core';
import { MunilyTitlePreviewSize } from 'src/app/common-components/title-preview/title-preview.types';

@Component({
  selector: 'app-title-preview-playground',
  templateUrl: './title-preview-playground.component.html',
  styleUrls: ['./title-preview-playground.component.scss'],
})
export class TitlePreviewPlaygroundComponent {
  value = 'Nombre de la reserva';
  showEditIcon = true;
  size: MunilyTitlePreviewSize = 'large';
  lastEvent = '';

  onEdit(): void {
    this.lastEvent = `edit @ ${new Date().toLocaleTimeString()}`;
  }
}
